import { Navigate } from 'react-router'

export function AgentStudioHomePage() {
  return <Navigate to="agents" />
}
